var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgYahooFantasyWordmark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "62.3 135.1 168.5 22.9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #7d2eff;\n      }\n\n      .st2 {\n        clip-path: url(#clippath);\n      }\n    "), /*#__PURE__*/React.createElement("clipPath", {
    id: "clippath"
  }, /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    x: 62.3,
    y: 135.1,
    width: 168.5,
    height: 22.9
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "st2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M148.4,140.9h3v3.6h-3v8.7h-4.5v-8.7h-1.7v-3.6h1.7v-.3c0-3.4,2-5.4,5.5-5.4s1.6.1,2.2.4v3.7c-.4-.2-.8-.3-1.3-.3-1.1,0-1.9.5-1.9,1.7v.2h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M186,137.4v3.5h2.9v3.6h-2.9v3.3c0,1.3.5,1.7,1.5,1.7s.9-.1,1.3-.4v3.8c-.6.3-1.5.6-2.9.6-2.8,0-4.5-1.7-4.5-4.6v-4.4h-1.7v-3.6h1.7v-3.5h4.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.8,140.7c-1.4,0-2.5.5-3.2,1.5v-1.2h-4.3v12.3h4.3v-6.6c0-1.3.6-2,1.6-2s1.5.7,1.5,1.9v6.7h4.3v-7.7c0-3-1.6-4.9-4.2-4.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M226.1,141l-2.8,7.2-2.8-7.2h-4.7l5.3,12.4-1.9,4.5h4.6l7-16.9h-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.6,149.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5,2.5,1.1,2.5,2.5-1.1,2.5-2.5,2.5ZM161.1,142.1c-.7-.9-1.9-1.4-3.3-1.4-3.4,0-5.9,3-5.9,6.5s2.5,6.5,5.9,6.5,2.6-.6,3.3-1.5v1.2h4.2v-12.3h-4.2v1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M196.7,149.7c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5,2.5,1.1,2.5,2.5-1.1,2.5-2.5,2.5ZM199.1,142.1c-.7-.9-1.9-1.4-3.3-1.4-3.4,0-5.9,3-5.9,6.5s2.5,6.5,5.9,6.5,2.6-.6,3.3-1.5v1.2h4.2v-12.3h-4.2v1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M209.8,153.6c-2.2,0-4.2-.6-5.7-1.7l1.8-3.1c1.2.8,3,1.3,4.2,1.3s1.1-.3,1.2-.6c0-.4-.1-.7-1.4-.9l-.9-.2c-2.9-.7-4.2-1.9-4.2-3.6,0-2.5,2.1-4.2,5.3-4.2s3.4.5,5.2,1.4l-1.5,3.2c-1.3-.7-2.8-1.1-3.8-1.1s-.9.2-.9.6.3.6,1.4.8l.9.2c2.9.8,4.1,1.9,4.1,3.6,0,2.7-2.2,4.3-5.5,4.3h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M83.1,149.6c-1.4,0-2.5-1.1-2.5-2.5s1.1-2.5,2.5-2.5,2.5,1.1,2.5,2.5-1.1,2.5-2.5,2.5ZM85.5,142.1c-.7-.9-1.9-1.4-3.3-1.4-3.4,0-5.9,3-5.9,6.5s2.5,6.5,5.9,6.5,2.6-.6,3.3-1.5v1.2h4.2v-12.3h-4.2v1.2Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M98.8,140.6c-1.4,0-2.5.5-3.2,1.5v-6.7h-4.3v17.8h4.3v-6.6c0-1.3.6-2,1.6-2s1.5.7,1.5,1.9v6.7h4.3v-7.7c0-3-1.6-4.9-4.2-4.9h0Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M124.4,149.6c-1.4,0-2.5-1.1-2.5-2.5s1-2.5,2.5-2.5,2.5,1.1,2.5,2.5-1,2.5-2.5,2.5ZM124.4,140.6c-3.8,0-6.6,2.8-6.6,6.5s2.8,6.5,6.6,6.5,6.6-2.8,6.6-6.5-2.8-6.5-6.6-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M110.5,149.6c-1.4,0-2.5-1.1-2.5-2.5s1-2.5,2.5-2.5,2.5,1.1,2.5,2.5-1,2.5-2.5,2.5ZM110.5,140.6c-3.8,0-6.6,2.8-6.6,6.5s2.8,6.5,6.6,6.5,6.6-2.8,6.6-6.5-2.8-6.5-6.6-6.5Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M72.7,140.9l-2.9,7.2-2.8-7.2h-4.7l5.3,12.4-1.9,4.5h4.6l7-16.9h-4.6Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M134.4,147.7c-1.7,0-2.9,1.3-2.9,2.9s1.2,2.8,2.8,2.8,2.9-1.3,2.9-2.9-1.2-2.8-2.8-2.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M137.7,135.5l-4.6,11.2h5.2l4.6-11.2h-5.2Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYahooFantasyWordmark);
export default __webpack_public_path__ + "static/media/yahoo-fantasy-wordmark.300c0fc65b797ac06eba2de25934d332.svg";
export { ForwardRef as ReactComponent };